import { useCustomClient } from '@uag/react-core';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

const idsApiClient = axios.create({
    baseURL: import.meta.env.VITE_APP_API_URL, //
});

const notificationsApiCLient = axios.create({
    baseURL: `${import.meta.env.VITE_APP_NOTIFICATIONS_API_URL}`,
});

export type ErrorType<Error> = AxiosError<Error>;

export const useCustomIDSClient = <T,>(): ((config: AxiosRequestConfig) => Promise<T>) => useCustomClient<T>(true, idsApiClient);
export const useCustomNotificationsClient = <T,>(): ((config: AxiosRequestConfig) => Promise<T>) => useCustomClient<T>(true, notificationsApiCLient);
